import { ReportChartGroupItemMeasure } from '@vision/ui/interfaces';

export const PieChart3Measures: ReportChartGroupItemMeasure[] = [
  {
    type: 'feedback',
    items: ['feedback-count', 'feedback-fcr'],
  },
  {
    type: 'response',
    items: ['response-count'],
  },
  {
    type: 'customer',
    items: ['customer-count'],
  },
];
